export default __webpack_public_path__ + "static/media/customer-call-log-button.802e1bd9.png";